import { useState } from 'react';

import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/outline';

import ReportCountries from './sidebar/ReportCountries';
import ReportMetrics from './sidebar/ReportMetrics';
import ReportPublishers from './sidebar/ReportPublishers';

/**
 * Main sidebar component for filtering dimensions and metrics
 * Features collapsible sections, search functionality
 * @returns {JSX.Element} Sidebar with dimension and metric filters
 */
export default function Sidebar() {
  const [isCollapsed, setIsCollapsed] = useState(() => {
    const stored = localStorage.getItem('sidebarCollapsed');
    return stored ? JSON.parse(stored) : false;
  });

  /**
   * Handle sidebar collapse
   * @param {boolean} collapsed
   */
  function handleCollapse(collapsed) {
    setIsCollapsed(collapsed);
    localStorage.setItem('sidebarCollapsed', JSON.stringify(collapsed));
  }

  return (
    <div
      className={`${isCollapsed ? 'md:w-12' : 'w-72'} min-h-screen p-4 relative transition-all duration-300 ease-in-out border-r`}
    >
      <button
        onClick={() => handleCollapse(!isCollapsed)}
        className="top-8 -right-3 z-10 absolute bg-base-100 hover:bg-base-200 p-1 border rounded-full"
      >
        {isCollapsed ? (
          <ChevronRightIcon className="w-4 h-4" />
        ) : (
          <ChevronLeftIcon className="w-4 h-4" />
        )}
      </button>

      <div className={`space-y-4 ${isCollapsed ? 'hidden' : 'block'}`}>
        <ReportPublishers />

        <ReportCountries />

        <ReportMetrics />
      </div>
    </div>
  );
}
